import { AttachedFile, FileResponse } from 'types/chat';

export const transformFileResponse = (file: FileResponse): AttachedFile => {
  const { fileId, filename, mimeType, kind, downloadUrl, width, height } = file;

  return {
    fileId,
    fileName: filename,
    mimeType,
    kind,
    downloadUrl,
    width,
    height,
  };
};
